import { ReactNode } from "react";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { SaleBanner } from "@/components/store/SaleBanner";
import { GlobalSearch } from "@/components/search/GlobalSearch";

interface LayoutProps {
  children: ReactNode;
}

export function Layout({ children }: LayoutProps) {
  return (
    <div className="min-h-screen flex flex-col">
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-[100] focus:px-4 focus:py-2 focus:bg-primary focus:text-primary-foreground focus:rounded-md focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2"
      >
        Skip to content
      </a>
      <Header />
      {/* min-h-screen keeps the footer below the fold while page content loads,
          so it doesn't jump into view and back (layout shift). */}
      <main id="main-content" className="flex-1 min-h-screen pt-16 md:pt-20">
        <SaleBanner />
        {children}
      </main>
      <Footer />
      <GlobalSearch />
    </div>
  );
}
